module.exports = __webpack_public_path__ + "assets/img/typeIcon-2.9632d5a3.svg";